// jshint esversion: 8

export default class {
  constructor (data) {
    const errMsg = 'Unable to parse the provided error';
    switch (typeof data) {
      case 'string':
        if( data.length === 0 ) {
          throw new TypeError(errMsg);
        } else {
          this.RAW_DATA = [data];
        }
        break;
      case 'object':
        if (data === null) {
          throw new TypeError(errMsg);
        } else {
          this.RAW_DATA = data;
        }
        break;
      default:
        throw new TypeError(errMsg);
    }
  }
  isArray (data) {
    return !!(data instanceof Array);
  }
  arrangeErrorMessage (data) {
    return `${Object.keys(data)[0]}: ${data[Object.keys(data)[0]]}`;
  }
  parse () {
    const rawData = this.RAW_DATA;
    let parsed = [];
    let proceed = false;
    if (this.isArray(rawData)) {
      return rawData.map((e, i) => {
        let obj = {};
        obj[`General Error ${i}`] = e;
        return obj;
      });
    } else {
      let tempObj = rawData; // temp = { e1: { e1a: ['v1'] }, e2: ['v2'] }
      let loops = 0;
      while (!proceed) {
        loops ++;
        proceed = true;
        let tempArr = [];
        for (var key in tempObj) {
          if (key === 'status') {
            if (tempObj[key] == 401) {
              return [ { 'Not Authorized': 'You are not authorized to perform this action' } ];
            }
            if (tempObj[key] == 404) {
              return [ { 'Not Found': 'The requested resource could not be found' } ];
            }
            // TODO: Add case for 400
          }
          if (tempObj.hasOwnProperty(key)) {
            let data = tempObj[key];
            if (this.isArray(data)) {
              let temp = {};
              temp[key] = data[0];
              parsed.push(temp);
            } else {
              proceed = false;
              tempArr.push(data);
            }
          }
        }
        tempObj = {};
        for (var i = 0; i < tempArr.length; i++) {
          let obj = tempArr[i];
          let keys = Object.keys(obj);
          for (var j = 0; j < keys.length; j++) {
            tempObj[keys[i]] = obj[keys[i]];
          }
        }
        if (loops > 10) {
          return [ { 'Unhandled Exception': 'There was an error with the request, but we are unable read it at this time' } ];
        }
      }
      return parsed;
    }
  }
}

/*
  this.RAW_DATA = some json object looks like
  {
    field_1: {
      field_1_a: {},
      field_1_b: [],
    },
    field_2 : [],
  }
  want to get it to be an array of messages
*/
